var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "22px",
    viewBox: "0 0 14 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-413.000000, -624.000000)",
    fill: "#B4C3D0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help",
    transform: "translate(0.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4722596,35.7878621 L46.2724957,35.7878621 L46.2724957,38.84 L43.4722596,38.84 L43.4722596,35.7878621 Z M47.7840115,20.3467833 C47.2365849,19.6413632 46.3281428,19.2886532 45.0624131,19.2885811 C43.4952502,19.2885811 42.4119961,19.8958101 41.8127888,21.1082509 C41.4766969,21.7836302 41.2826225,22.7575451 41.2365721,24.0301397 L38.7321079,24.0301397 C38.7321079,21.9158965 39.3044582,20.2165342 40.4491589,18.9298917 C41.5938596,17.6432492 43.1648888,17 45.1623155,17 C47.0099922,17 48.4888516,17.5490923 49.6008268,18.6513113 C50.7128711,19.7535302 51.2678921,21.1604082 51.2678921,22.8718012 C51.2678921,23.9099042 51.0623569,24.7515528 50.6552218,25.3968912 C50.2480867,26.0422296 49.4260149,26.9920829 48.1872803,28.2446503 C47.2865016,29.1565384 46.7026214,29.9260024 46.4357087,30.5572929 C46.168727,31.1885834 46.034304,32.1204987 46.034304,33.3529668 L43.5298398,33.3529668 C43.5298398,31.9541573 43.6892556,30.8258598 44.0080872,29.9701632 C44.3269188,29.1123776 45.0240953,28.1324833 46.1034832,27.0262301 L47.2289214,25.8658745 C47.5670154,25.5332638 47.8377254,25.1845159 48.0432606,24.8238094 C48.4177393,24.1865395 48.6060143,23.5272253 48.6060143,22.8418324 C48.6060143,21.8839105 48.3333021,21.0522035 47.7840115,20.3467833 Z",
    id: "ic/help"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.4f5d4ae36e3ec2e8a364bf8a4e913c30.svg";
export { ForwardRef as ReactComponent };